<label class="box" cdkOverlayOrigin #origin="cdkOverlayOrigin">
  <span class="material-symbols-outlined" aria-hidden="true">search</span>
  <span class="visually-hidden">Find a reservation or user</span>
  <input
    #input
    type="search"
    autocomplete="off"
    spellcheck="false"
    placeholder="r-123, name, email or phone"
    role="combobox"
    aria-autocomplete="list"
    [attr.aria-controls]="open ? 'admin-search-results' : null"
    [attr.aria-expanded]="open"
    [attr.aria-activedescendant]="open && options.length ? optionId(active) : null"
    (input)="onInput(input.value)"
    (keydown)="onKey($event)"
    (focus)="open = text.trim().length > 0"
  />
  <kbd aria-hidden="true">/</kbd>
</label>
<!-- Outside the overlay, so it's on the page before results arrive and screen readers hear the count. -->
<p class="visually-hidden" role="status">{{ status }}</p>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayWidth]="panelWidth"
  (overlayOutsideClick)="$event.target !== input && close()"
  (detach)="close()"
>
  <div class="panel">
    <ul id="admin-search-results" role="listbox" aria-label="Search results">
      @for (option of options; track option.key; let i = $index) {
        <li
          role="option"
          [id]="optionId(i)"
          [attr.aria-selected]="i === active"
          [class.active]="i === active"
          (mousedown)="$event.preventDefault()"
          (click)="go(option)"
          (mouseenter)="active = i"
        >
          @if (option.reservation; as r) {
            <span class="material-symbols-outlined" aria-hidden="true">confirmation_number</span>
            <span class="text">
              <strong>r-{{ r.id }} · {{ r.site?.listing?.name || 'Reservation' }}</strong>
              <small>
                {{ r.user?.firstName }} {{ r.user?.lastName }} · {{ r.date?.from | date: 'mediumDate' }} –
                {{ r.date?.to | date: 'mediumDate' }}
              </small>
            </span>
            <admin-status-chip kind="reservation" [value]="r.status"></admin-status-chip>
          } @else if (option.user; as u) {
            <span class="material-symbols-outlined" aria-hidden="true">person</span>
            <span class="text">
              <strong
                >{{ userName(u) }} <span class="id">#{{ u.id }}</span></strong
              >
              <small>{{ u.email }}{{ u.phone ? ' · ' + u.phone : '' }}</small>
            </span>
            <admin-status-chip kind="role" [value]="u.role"></admin-status-chip>
          } @else if (option.upcoming; as b) {
            <span class="material-symbols-outlined sub-icon" aria-hidden="true">event</span>
            <span class="text">
              <strong>r-{{ b.reservation.id }} · {{ b.reservation.site?.listing?.name || 'Reservation' }}</strong>
              <small>
                {{ b.role === 'guest' ? 'Staying' : 'Hosting' }} · {{ b.reservation.date?.from | date: 'mediumDate' }} –
                {{ b.reservation.date?.to | date: 'mediumDate' }}
              </small>
            </span>
            <admin-status-chip kind="reservation" [value]="b.reservation.status"></admin-status-chip>
          } @else {
            <span class="material-symbols-outlined" aria-hidden="true">group</span>
            <span class="text"
              ><strong>See all users matching “{{ option.allUsers }}”</strong></span
            >
          }
        </li>
      }
    </ul>
    @if (searching) {
      <p class="note">Searching…</p>
    } @else if (!options.length) {
      <p class="note">
        @if (lookup.reservationOnly) {
          No reservation r-{{ lookup.reservationId }}.
        } @else if (!lookup.userTerm && !lookup.reservationId) {
          Type at least two characters.
        } @else {
          Nothing found for “{{ text.trim() }}”.
        }
      </p>
    }
  </div>
</ng-template>
